import React from 'react';
import styles from './CenteredModalContent.module.scss';

interface CenteredModalContentProps {
    children: React.ReactNode;
    className?: string;
    padding?: 'none' | 'small' | 'medium' | 'large' | 'xlarge';
    scrollable?: boolean;
}

export const CenteredModalContent: React.FC<CenteredModalContentProps> = ({
    children,
    className,
    padding = 'xlarge',
    scrollable = true
}) => {
    const paddingClass = {
        none: styles.paddingNone,
        small: styles.paddingSmall,
        medium: styles.paddingMedium,
        large: styles.paddingLarge,
        xlarge: styles.paddingXLarge
    }[padding];

    const scrollClass = scrollable ? styles.scrollable : styles.noScroll;

    return (
        <div className={`
            ${styles.modalContent} 
            ${paddingClass} 
            ${scrollClass} 
            ${className || ''}
        `}>
            {children}
        </div>
    );
};

export default CenteredModalContent;
